// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ops-planner-container cat-radio-field::part(part-label) {
    background-color: #f1f1f1;
}

.ops-planner-container cat-dropdown::part(part-base) {
    width: 160px;
}

.local-time-cest-format {
    font-weight: 400;
    font-size: 16px;
    color: #3f3f3f;
    line-height: 24px;
    margin-top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/OpsPLanner/OpsPlanner.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".ops-planner-container cat-radio-field::part(part-label) {\n    background-color: #f1f1f1;\n}\n\n.ops-planner-container cat-dropdown::part(part-base) {\n    width: 160px;\n}\n\n.local-time-cest-format {\n    font-weight: 400;\n    font-size: 16px;\n    color: #3f3f3f;\n    line-height: 24px;\n    margin-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
